export enum NotificationType {
  AutoMuteLargeRoom = 'autoMuteLargeRoom',
  ParticipantJoined = 'participantJoined',
  HandRaised = 'handRaised',
  ParticipantMuted = 'participantMuted',
  MessageReceived = 'messageReceived',
  LowerHand = 'lowerHand',
  ReactionReceived = 'reactionReceived',
  ParticipantWaiting = 'participantWaiting',
  TranscriptionStarted = 'transcriptionStarted',
  TranscriptionStopped = 'transcriptionStopped',
  TranscriptionLimitReached = 'transcriptionLimitReached',
  TranscriptionFailed = 'transcriptionFailed',
  TranscriptionAborted = 'transcriptionAborted',
  TranscriptionRequested = 'transcriptionRequested',
  ScreenRecordingStarted = 'screenRecordingStarted',
  ScreenRecordingStopped = 'screenRecordingStopped',
  ScreenRecordingRequested = 'screenRecordingRequested',
  ScreenRecordingLimitReached = 'screenRecordingLimitReached',
  ScreenRecordingFailed = 'screenRecordingFailed',
  ScreenRecordingAborted = 'screenRecordingAborted',
  RecordingSaving = 'recordingSaving',
  PermissionsRemoved = 'permissionsRemoved',
  RoleChanged = 'roleChanged',
}
